module.exports = __webpack_public_path__ + "img/coupon-popup-item-empty-hen.66168466.png";